import { NotificationDefinition } from '../../types'
import { IntegrationSyncErrorHeader } from './IntegrationSyncErrorHeader'
import { IntegrationSyncErrorListItem } from './IntegrationSyncErrorListItem'
import { IntegrationSyncErrorPreview } from './IntegrationSyncErrorPreview'
import { ViewInIntegrationAction } from './ViewInIntegrationAction'

export const integrationSyncErrorDefinition: NotificationDefinition = {
  listItemContent: IntegrationSyncErrorListItem,
  previewHeaderContent: IntegrationSyncErrorHeader,
  previewContent: IntegrationSyncErrorPreview,
  previewHeaderActions: ViewInIntegrationAction
}
